import React from "react";
import { AcaoPermissao, usePermissaoTela } from "../../hooks/usePermissaoTela";

interface Props {
  /** Ação exigida: ACESSAR, SALVAR, REMOVER, CONHECER, AUDITAR, EXPORTAR... */
  acao: AcaoPermissao;
  /** Força a chave da tela quando a rota não está nos menus. */
  chave?: string;
  /** Renderizado quando o usuário NÃO tem a permissão (por padrão, nada). */
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Renderiza os filhos apenas se o usuário tiver a permissão informada na tela
 * atual. Ex.: <Can acao="SALVAR"><button>Adicionar</button></Can>
 */
const Can: React.FC<Props> = ({ acao, chave, fallback = null, children }) => {
  const { can } = usePermissaoTela(chave);
  return <>{can(acao) ? children : fallback}</>;
};

export default Can;
